import type { GetServerSideProps } from 'next';
import Head from 'next/head';
import { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';

import NextApiService from 'services/api';

const DemoLogin: React.FC = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const api = NextApiService();
      await api.post('/auth/demo-login', { firstName, lastName, email });
      window.location.href = '/';
    } catch {
      setError('Something went wrong. Please try again.');
      setLoading(false);
    }
  };

  return (
    <>
      <Head>
        <title>Atlas Insurance — Sign In</title>
      </Head>

      <div
        style={{
          backgroundColor: 'var(--white)',
          minHeight: 'calc(100vh - 13rem)',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingTop: '4rem',
          paddingBottom: '3rem',
          paddingLeft: '1rem',
          paddingRight: '1rem',
        }}
      >
        <div
          style={{
            backgroundColor: 'var(--white)',
            borderRadius: 'var(--card-radius)',
            boxShadow: 'var(--card-shadow)',
            border: 'var(--card-border)',
            padding: '2rem 1.5rem',
            width: '100%',
            maxWidth: '420px',
          }}
        >
          <h4
            style={{
              fontWeight: 700,
              marginBottom: '0.4rem',
              color: 'var(--primary)',
            }}
          >
            Login
          </h4>
          <p
            style={{
              color: 'var(--dark-grey)',
              marginBottom: '1.75rem',
              fontSize: '0.9rem',
            }}
          >
            Please enter your details to access the claims portal.
          </p>

          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="firstName" style={{ marginBottom: '1rem' }}>
              <Form.Label
                style={{
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  marginBottom: '0.3rem',
                }}
              >
                First name *
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Jane"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                required
                disabled={loading}
              />
            </Form.Group>

            <Form.Group controlId="lastName" style={{ marginBottom: '1rem' }}>
              <Form.Label
                style={{
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  marginBottom: '0.3rem',
                }}
              >
                Last name *
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Smith"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                required
                disabled={loading}
              />
            </Form.Group>

            <Form.Group controlId="email" style={{ marginBottom: '1.5rem' }}>
              <Form.Label
                style={{
                  fontWeight: 600,
                  fontSize: '0.875rem',
                  marginBottom: '0.3rem',
                }}
              >
                Email *
              </Form.Label>
              <Form.Control
                type="email"
                placeholder="jane@company.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </Form.Group>

            {error && (
              <p
                style={{
                  color: '#dc3545',
                  fontSize: '0.875rem',
                  marginBottom: '1rem',
                }}
              >
                {error}
              </p>
            )}

            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="mr-2" />
                  Signing in...
                </>
              ) : (
                'Access the portal'
              )}
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async () => ({
  props: { title: 'Welcome', backgroundImage: '/images/office1.jpg' },
});

export default DemoLogin;
